<template>
  <DropDownFilter
    :menuSections="dropDownMenuSections"
    :setLoadingOverlay="setLoadingOverlay"
    storeModule="SystemCollection"
  />
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import DropDownFilter from 'client/components/ItemTable/CollectionFilterComponents/DropDownFilter.vue';
import DropDownFilterMixin from 'client/components/ItemTable/mixins/DropDownFilterMixin';
import SystemDropDownFilterMixin from 'client/components/ItemTable/mixins/SystemDropDownFilterMixin';

export default {
  name: 'SystemDropDownFilter',

  components: {
    DropDownFilter,
  },

  mixins: [
    DropDownFilterMixin,
    SystemDropDownFilterMixin,
  ],

  computed: {
    // mapped getters used in DropDownFilterMixin
    ...mapGetters('SystemCollection', [
      'getFilters',
    ]),
  },

  mounted() {
    this.handleMounted();
  },

  methods: {
    // mapped actions used in DropDownFilterMixin
    ...mapActions('SystemCollection', [
      'fetchCollection',
      'setFilter',
      'setFilters',
    ]),
  },
};
</script>
